export const config = {
  TITLE: 'Program Tuisyen Kelantan',
  SUBTITLE: 'Program Tuisyen Kelantan (ePTRS)',
  DESCRIPTION:
    'Program Tuisyen Kelantan ialah program khusus untuk meningkatkan kualiti hidup rakyat melalui sokongan pembelajaran berfokuskan 5M (membaca, menulis, mengira, memikir dan mengamal), selaras dengan fokus utama Kerajaan Negeri Kelantan.',
  SERVER_ENDPOINT: 'https://api.kelantan.eptrs.my/api',
  CLIENT_ENDPOINT: 'https://kelantan.eptrs.my',
  DEFAULT_LANGUAGE: 'my',
  DEFAULT_THEME: 'light',
};
